import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import AssignmentIcon from '@material-ui/icons/Assignment'

function DetalleMercaderia (props) {
  const { titulo, contenido } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Dialog
        onClose={handleClose}
        maxWidth='xl'
        open={open}
      >
        <DialogView
          cancelCallback={handleClose}
          title={titulo}
          content={contenido}
        />
      </Dialog>
      <Tooltip title='Ver detalle'>
        <IconButton onClick={handleOpen}>
          <AssignmentIcon fontSize='small' color='primary' />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default DetalleMercaderia
